import { render, staticRenderFns } from "./editClassroom.vue?vue&type=template&id=a149db0a&scoped=true&"
import script from "./editClassroom.vue?vue&type=script&lang=js&"
export * from "./editClassroom.vue?vue&type=script&lang=js&"
import style0 from "./editClassroom.vue?vue&type=style&index=0&id=a149db0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a149db0a",
  null
  
)

export default component.exports